<template>
  <div>
    <!-- <p class="header"> 职工诉求</p> -->
    <p class="header">共计{{ totalNum }}条诉求</p>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="queryAppealList"
      :immediate-check="false"
    >
      <van-cell
        v-for="appeal in appealList"
        :key="appeal.id"
        size="large"
        :label="appeal.content"
        is-link
        @click="viewDetail(appeal.id)"
      >
        <template #title>
          <div style="font-size: 16px">{{ appeal.name }}</div>
          <div style="font-size: 15px">
            {{ appeal.company ? appeal.company : "未知部门" }}
          </div>
        </template>
        <template #default>
          <van-tag v-if="+appeal.isHandle" type="success">已回复</van-tag>
          <van-tag v-else type="warning">待回复</van-tag>
          <!-- <span class="ellipsis">...</span> -->
          <span class="date">{{ formatDate(new Date(appeal.created)) }}</span>
        </template>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import service from "../../api/service";
import dayjs from "dayjs";

const RoleEnum = {
  NonExist: -1,
  Approver: 0, //审批人
  Appellant: 1, //诉求者
};

export default {
  data() {
    return {
      appealList: [],
      loading: false,
      finished: false,
      pagingProps: {
        page: 1,
        size: 10,
      },
      totalNum: 0,
    };
  },
  mounted() {
    this.queryAppealList();
  },
  methods: {
    viewDetail(id) {
      this.$router.push({
        name: "appealDetail",
        query: {
          id,
        },
      });
    },
    formatDate(date, format = "YYYY-MM-DD") {
      try {
        return dayjs(date).format(format);
      } catch {
        return "";
      }
    },
    getRoleAuth() {
      let whiteList = [
        "owgoM5xBlbOVG5EBDLj8TAiaiEX0",
        "owgoM52a6us4hPk5xTLRn9JCQXZ8",
        // "owgoM55QDcgG4U075UhjkZEJogw4" //ProlanJR
      ];

      const user = this.$store.state.user;

      if (!user) {
        this.$toast("用户信息不存在！");
        return RoleEnum.NonExist;
      }

      for (let openid of whiteList) {
        if (user.openid == openid) {
          return RoleEnum.Approver;
        }
      }
      return RoleEnum.Appellant;
    },
    queryAppealList() {
      const role = this.getRoleAuth();
      if (role == RoleEnum.Approver) {
        var params = {};
      } else if (role == RoleEnum.Appellant) {
        let { userName: name, phone } = this.$store.state.user;
        var params = {
          name,
          phone,
        };
        // var params = {};
      } else return;

      service
        .post("/api/appeal/findPersonal", { ...params, ...this.pagingProps })
        .then((res) => {
          this.loading = false;
          if (res.status === 200) {
            this.totalNum = res.total;
            if (!res.data.length) {
              this.finished = true;
              return;
            }
            this.pagingProps.page++;
            this.appealList = [...this.appealList, ...res.data];
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  padding: 0 16px;
  font-weight: bold;
}
.van-cell__label {
  white-space: pre-wrap;
  // line-height: 18px;
  height: calc(18px * 3);

  // 多行超出省略
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.van-cell__value {
  flex: 0.5;
}

// .ellipsis {
//   position: absolute;
//   left: 2.5px;
//   bottom: -2.5px;
// }

.date {
  position: absolute;
  right: 0;
  bottom: -2.5px;
}
</style>